const styles = {
  headerStyle: {
    fontSize: 24,
    padding: "16px 0px",
  },
  firstGradeItem: {
    paddingTop: 0,
  },
  lastGradeItem: {
    paddingBottom: 0,
    border: "none",
  },
  titleContainer: { fontSize: 16, fontWeight: "600" },
};

export default styles;
